import { cn } from '@/shared/lib'

// Фирменные логотипы STIT из public/brand (белые по прозрачному — фирстиль
// тёмный by design). img, не inline-SVG: файлы приходят от бренда как есть.

export function BrandLogo({ className }: { className?: string }) {
  return <img src="/brand/stit.svg" alt="STIT" className={cn('w-auto select-none', className)} />
}

export function EcosystemsLogo({ className }: { className?: string }) {
  return (
    <img
      src="/brand/stit-ecosystems.svg"
      alt="STIT — разработка эко-систем"
      className={cn('w-auto select-none', className)}
    />
  )
}
